import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';
import withSidebar from '../utils/hocs/withSidebar';
import withAuth from '../utils/hocs/withAuth';

// Icons
import { ReactComponent as FileIcon } from '../assets/icons/file.svg';
import { ReactComponent as ToolsIcon } from '../assets/icons/tools.svg';

// Components
import PageWrapper from '../components/layout/PageWrapper/PageWrapper';
import General from '../components/tabs/establishment/General/General';
import Equipments from '../components/tabs/establishment/Equipments/Equipments';

const tabsBar = [
  {
    label: 'establishment.tabs.general',
    component: <General />,
    icon: <FileIcon />,
  },
  {
    label: 'establishment.tabs.equipments',
    component: <Equipments />,
    icon: <ToolsIcon />,
  },
];

function Establishment({ children }) {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('establishment.title')}
    >
      {children}
    </PageWrapper>
  );
}

Establishment.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withAuth(
  withSidebar(Establishment, {
    tabsBar,
  }),
);
